var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 57,
    viewBox: "0 0 52 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0951 18.5719H7.26189C4.35583 18.5719 2 21.5373 2 25.1953V48.377C2 52.035 4.35583 55.0004 7.26189 55.0004H44.0951C47.0012 55.0004 49.357 52.035 49.357 48.377V25.1953C49.357 21.5373 47.0012 18.5719 44.0951 18.5719Z",
    stroke: "#ED1D38",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18V10.8889C14 8.53141 15.2116 6.27049 17.3683 4.6035C19.5249 2.93651 22.45 2 25.5 2C28.55 2 31.4751 2.93651 33.6317 4.6035C35.7884 6.27049 37 8.53141 37 10.8889V18",
    stroke: "#ED1D38",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.c780d47ea3f3e05c07183b96848887c8.svg";
export { ForwardRef as ReactComponent };